import { formatDistanceToNow, parseISO } from "date-fns";
export class ExportParamsModel {
    constructor(data = {}) {
        Object.defineProperty(this, "_params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._params = data;
    }
    get modelStoreFormat() {
        var _a, _b;
        return (_b = (_a = this._params) === null || _a === void 0 ? void 0 : _a.model_store_format) !== null && _b !== void 0 ? _b : "tgz";
    }
    get includeFiles() {
        var _a;
        return Boolean((_a = this._params) === null || _a === void 0 ? void 0 : _a.include_files);
    }
    get includeDeleted() {
        var _a;
        return Boolean((_a = this._params) === null || _a === void 0 ? void 0 : _a.include_deleted);
    }
    get includeHidden() {
        var _a;
        return Boolean((_a = this._params) === null || _a === void 0 ? void 0 : _a.include_hidden);
    }
    equals(otherExportParams) {
        if (!otherExportParams) {
            return false;
        }
        return (this.modelStoreFormat === otherExportParams.modelStoreFormat &&
            this.includeFiles === otherExportParams.includeFiles &&
            this.includeDeleted === otherExportParams.includeDeleted &&
            this.includeHidden === otherExportParams.includeHidden);
    }
}
export class ExportRecordModel {
    constructor(data) {
        var _a, _b, _c;
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_expirationDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_requestMetadata", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_exportParameters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._data = data;
        this._expirationDate = undefined;
        this._requestMetadata = (_a = data.export_metadata) === null || _a === void 0 ? void 0 : _a.request_data;
        this._exportParameters = ((_b = this._requestMetadata) === null || _b === void 0 ? void 0 : _b.payload)
            ? new ExportParamsModel((_c = this._requestMetadata) === null || _c === void 0 ? void 0 : _c.payload)
            : undefined;
    }
    get id() {
        return this._data.id;
    }
    get isReady() {
        var _a;
        return (_a = (this._data.ready && !this.hasExpired)) !== null && _a !== void 0 ? _a : false;
    }
    get isPreparing() {
        var _a;
        return (_a = this._data.preparing) !== null && _a !== void 0 ? _a : false;
    }
    get isUpToDate() {
        var _a;
        return (_a = this._data.up_to_date) !== null && _a !== void 0 ? _a : false;
    }
    get hasFailed() {
        return !this.isReady && !this.isPreparing && !this.hasExpired;
    }
    get date() {
        return parseISO(`${this._data.create_time}Z`);
    }
    get elapsedTime() {
        return formatDistanceToNow(this.date, { addSuffix: true });
    }
    get taskUUID() {
        return this._data.task_uuid;
    }
    get importUri() {
        var _a;
        const payload = (_a = this._requestMetadata) === null || _a === void 0 ? void 0 : _a.payload;
        return payload && "target_uri" in payload ? payload.target_uri : undefined;
    }
    get canReimport() {
        return this.isReady && Boolean(this.importUri);
    }
    get stsDownloadId() {
        var _a;
        const payload = (_a = this._requestMetadata) === null || _a === void 0 ? void 0 : _a.payload;
        return payload && "short_term_storage_request_id" in payload
            ? payload.short_term_storage_request_id
            : undefined;
    }
    get isStsDownload() {
        return Boolean(this.stsDownloadId);
    }
    get canDownload() {
        return this.isReady && this.isStsDownload && !this.hasExpired;
    }
    get modelStoreFormat() {
        var _a, _b;
        return (_b = (_a = this.exportParams) === null || _a === void 0 ? void 0 : _a.modelStoreFormat) !== null && _b !== void 0 ? _b : "tgz";
    }
    get exportParams() {
        return this._exportParameters;
    }
    get duration() {
        var _a;
        const payload = (_a = this._requestMetadata) === null || _a === void 0 ? void 0 : _a.payload;
        return payload && "duration" in payload ? payload.duration : undefined;
    }
    get canExpire() {
        return this.isStsDownload && Boolean(this.duration);
    }
    get isPermanent() {
        return !this.canExpire;
    }
    get expirationDate() {
        if (this._expirationDate === undefined) {
            this._expirationDate = this.duration ? new Date(this.date.getTime() + this.duration * 1000) : undefined;
        }
        return this._expirationDate;
    }
    get expirationElapsedTime() {
        return this.canExpire && this.expirationDate
            ? formatDistanceToNow(this.expirationDate, { addSuffix: true })
            : undefined;
    }
    get hasExpired() {
        return Boolean(this.canExpire && this.expirationDate && Date.now() > this.expirationDate.getTime());
    }
    get errorMessage() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._data) === null || _a === void 0 ? void 0 : _a.export_metadata) === null || _b === void 0 ? void 0 : _b.result_data) === null || _c === void 0 ? void 0 : _c.error;
    }
}
